<div class="clock-container" [matTooltip]="tooltip" matTooltipPosition="above" [matTooltipDisabled]="isMobile">
  {{ timeFormatted }}
</div>
